import type { ElementType, ReactNode } from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import {
  getTitleSectionSx,
  getTitleSx,
  getDescriptionSx,
  getRightColumnSx,
} from "./SectionHeader.sx";
import type { SectionHeaderAlignment } from "./SectionHeader.sx";

export interface SectionHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  rightContent?: ReactNode;
  titleComponent?: ElementType;
  alignment?: SectionHeaderAlignment;
  variant?: "light" | "dark";
}

export const SectionHeader = ({
  title,
  description,
  rightContent,
  titleComponent = "h2",
  alignment = "default",
  variant = "light",
}: SectionHeaderProps) => {
  const isDark = variant === "dark";
  const shouldRenderRightColumn = description != null || rightContent != null;

  return (
    <Stack sx={getTitleSectionSx(alignment)}>
      <Typography
        variant="h2"
        component={titleComponent}
        sx={getTitleSx(isDark, alignment)}
      >
        {title}
      </Typography>
      {shouldRenderRightColumn && (
        <Stack sx={getRightColumnSx(alignment)}>
          {description != null && (
            <Typography sx={getDescriptionSx(isDark)}>
              {description}
            </Typography>
          )}
          {rightContent}
        </Stack>
      )}
    </Stack>
  );
};

export default SectionHeader;
